import React, { useEffect, useState } from "react";
import { History, Loader2, UserPlus, UserMinus, UserCog, LogIn, CheckCircle2, XCircle, Mail } from "lucide-react";
import api from "@/lib/api";
import { MemberAvatar } from "@/components/MemberAvatar";

const ICONS = {
  "team.invite": Mail,
  "team.invite_revoked": XCircle,
  "team.joined": LogIn,
  "team.role_changed": UserCog,
  "team.removed": UserMinus,
  "afp.mark_paid": CheckCircle2,
  "afp.mark_unpaid": XCircle,
};

const timeAgo = (iso) => {
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return "just now";
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
};

const ActivityLog = () => {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/audit").then(({ data }) => setEvents(data.events)).catch(() => setEvents([]));
  }, []);

  if (events === null)
    return (
      <div className="bg-white border border-slate-200 rounded-xl p-6 flex items-center gap-2 text-slate-400" data-testid="activity-log-section">
        <Loader2 className="h-4 w-4 animate-spin" /> Loading activity…
      </div>
    );

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6" data-testid="activity-log-section">
      <h2 className="font-display text-lg font-bold text-slate-900 flex items-center gap-2">
        <History className="h-5 w-5 text-slate-400" /> Activity log
      </h2>
      <p className="text-sm text-slate-500 mt-1 mb-4">A record of team and payment activity in your workspace.</p>
      {events.length === 0 ? (
        <p className="text-sm text-slate-400 py-2" data-testid="activity-empty">No activity yet. Team invites and payment updates will show here.</p>
      ) : (
        <div className="space-y-3" data-testid="activity-list">
          {events.map((e) => {
            const Icon = ICONS[e.action] || History;
            return (
              <div key={e.id} className="flex items-start gap-3" data-testid={`activity-${e.action}`}>
                <div className="relative shrink-0 mt-0.5">
                  <MemberAvatar name={e.actor_name} picture={e.actor_picture} size="sm" testId={`activity-avatar-${e.id}`} />
                  <span className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full bg-white border border-slate-200 flex items-center justify-center">
                    <Icon className="h-2.5 w-2.5 text-slate-500" />
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-slate-700">{e.summary}</p>
                  <p className="text-xs text-slate-400">{e.actor_name} · {timeAgo(e.created_at)}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ActivityLog;
